<template>
  <div>
    <form>
      <v-select
        v-model="form.bezpecnostne_riziko"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.bezpecnostne_riziko"
        label="Bezpečnostné riziko odsúdeného počas výkonu trestu"
        name="Bezpečnostné riziko odsúdeného počas výkonu trestu"
        :error-messages="errors.collect('Bezpečnostné riziko odsúdeného počas výkonu trestu')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('bezpecnostne_riziko')"
      />

      <v-layout
        row
        wrap
        pt-5
      >
        <v-flex xs12>
          <v-subheader
            class="pl-0"
          >
            Expertné posúdenie - pravdepodobnosť, že posudzovaná osoba sa dopustí trestnej činnosti do 2 rokov od prepustenia
          </v-subheader>
          <v-slider
            v-model="form.expertne_posudenie"
            :tick-labels="selects.expertne_posudenie"
            always-dirty
            min="0"
            max="3"
            ticks="always"
            :color="color"
            :readonly="form.closed"
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('expertne_posudenie')"
          />
        </v-flex>
      </v-layout>

      <v-divider class="mt-10" />

      <v-textarea
        v-model="form.poznamky"
        :disabled="form.closed"
        label="Poznámky a doplňujúce informácie"
        auto-grow
        rows="1"
      />

      <v-layout
        v-if="!form.closed"
        pt-5
      >
        <v-btn
          dark
          color="primary"
          @click="updateItem"
        >
          Uložiť
        </v-btn>
        <div class="flex-grow-1" />
        <v-btn
          dark
          color="red"
          @click="closeItem"
        >
          Uložiť a uzatvoriť
        </v-btn>
      </v-layout>
      <v-layout
        v-else
        pt-5
      >
        <div class="flex-grow-1" />
        <v-btn
          v-if="!craItem.closed"
          dark
          color="green"
          @click="openItem"
        >
          Otvoriť
        </v-btn>
      </v-layout>
    </form>
    <v-snackbar
      v-model="snackbar_saved"
      color="success"
      :timeout="3000"
    >
      Uložené
      <v-btn
        text
        @click="snackbar_saved = false"
      >
        Zavrieť
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="snackbar_error"
      color="error"
      :timeout="5000"
    >
      Chyba
    </v-snackbar>

    <v-dialog
      v-model="dialog"
      width="800px"
    >
      <v-card>
        <v-toolbar
          dark
          color="indigo"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ dialog_item.nazov }}</v-toolbar-title>
          <div class="flex-grow-1" />
        </v-toolbar>
        <v-card>
          <v-card-title>
            <span class="headline">Charakteristika</span>
          </v-card-title>
          <v-card-text
            v-for="(item, index) in dialog_item.charakteristika"
            :key="index"
          >
            {{ item }}
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title>
            <span class="headline">Zdroj</span>
          </v-card-title>
          <v-card-text
            v-for="(item, index) in dialog_item.zdroj"
            :key="index"
          >
            {{ item }}
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title>
            <span class="headline">Príklad</span>
          </v-card-title>
          <v-card-text
            v-for="(item, index) in dialog_item.priklad"
            :key="index"
          >
            {{ item }}
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title>
            <span class="headline">Poznámka</span>
          </v-card-title>
          <v-card-text
            v-for="(item, index) in dialog_item.poznamka"
            :key="index"
          >
            {{ item }}
          </v-card-text>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { APIService } from "@/http/APIService.js";
import VeeValidate, { Validator } from "vee-validate";
import sk from "vee-validate/dist/locale/sk";

Vue.use(VeeValidate);
Validator.localize("sk", sk);

const apiService = new APIService();

export default {
  $_veeValidate: {
    validator: "new"
  },
  data: () => ({
    snackbar_saved: false,
    snackbar_error: false,
    dialog: false,
    dialog_item: {
      nazov: "",
      charakteristika: [],
      zdroj: [],
      poznamka: [],
      priklad: []
    },

    form: {
      id: null,
      bezpecnostne_riziko: "",
      expertne_posudenie: "0",
      skore: 0
    },
    craItem: {},

    selects: {
      bezpecnostne_riziko: ["žiadne", "nízke", "stredné", "vysoké"],
      expertne_posudenie: ["nehodnotené", "malá", "stredná", "vysoká"]
    },

    manual: {
      bezpecnostne_riziko: {
        name: "Bezpečnostné riziko odsúdeného počas výkonu trestu",
        charakteristika: [
          "Posudzuje sa bezpečnostné riziko vo vzťahu k aktuálnemu trestu odňatia slobody. Teda ak sa odsúdený dopustil rizikového správania aj v predchádzajúcom treste/trestoch odňatia slobody (napr. pripravoval útek) a na základe toho je PBS vyhodnotený ako rizikový aj v aktuálnom treste, môže byť v CR-CRA hodnotený ako odsúdený s bezpečnostným rizikom (ďalšie prípadné poznatky relevantné vo vzťahu k prognóze recidívy je potrebné uviesť v záverečnej časti hodnotenia v položke doplňujúce informácie)."
        ],
        zdroj: ["-"],
        priklad: [
          "nízke riziko:",
          "-> voči odsúdenému boli použité donucovacie prostriedky s výnimkou použitia spútavacích popruhov na psychiatrickom oddelení Nemocnice pre obvinených a odsúdených a Ústavu na výkon trestu odňatia slobody v Trenčíne a použitia donucovacích prostriedkov pri eskortovaní alebo predvádzaní obvineného alebo odsúdeného alebo dodávaní osoby aj preventívne, ako prostriedkov obmedzenia pohybu podľa osobitného predpisu;",
          "-> odsúdený sa pokúsil o samovraždu alebo sa úmyselne sebapoškodil; časté hladovky,",
          "-> odsúdený, ktorý nadväzoval nedovolené kontakty s inými osobami v rozpore so zákonmi a vyhláškami upravujúcimi výkon trestu odňatia slobody a výkon väzby;",
          "-> odsúdený so súdom nariadeným ochranným dohľadom;",
          "-> odsúdený, ktorý bol vyhodnotený podľa interných predpisov ako útekár (napr. útekár z detského domova; odsúdený, ktorý bol zadržaný na základe európskeho zatýkacieho rozkazu a pod.);",
          "stredné riziko:",
          "-> voči odsúdenému boli opakovane použité donucovacie prostriedky s výnimkou použitia spútavacích popruhov na psychiatrickom oddelení Nemocnice pre obvinených a odsúdených a Ústavu na výkon trestu odňatia slobody v Trenčíne a použitia donucovacích prostriedkov pri eskortovaní alebo predvádzaní obvineného alebo odsúdeného alebo dodávaní osoby aj preventívne, ako prostriedkov obmedzenia pohybu podľa osobitného predpisu;",
          "-> odsúdený, ktorý bol účastníkom bitky medzi obvinenými a odsúdenými s následkom ujmy na zdraví v trestnoprávnej rovine;",
          "-> odsúdený, ktorý sa vyhrážal príslušníkovi/zamestnancovi ozbrojeného zboru v súvislosti s výkonom jeho služby alebo práce, alebo inej civilnej osobe, ",
          "-> odsúdený sa nedovolene vzdialil alebo sa pokúsil o nedovolené vzdialenie sa z otvoreného oddelenia ústavu, nestráženého pracoviska mimo ústavu, nevrátil sa z udeleného mimoriadneho voľna na opustenie ústavu, opustenia ústavu, vychádzky mimo ústavu alebo voľného pohybu mimo otvoreného oddelenia;",
          "-> odsúdený, ktorý prechovával prostriedky audiovizuálnej techniky; odsúdený, ktorý vyrábal, prechovával alebo požíval vo výkone väzby a výkone trestu alkoholické nápoje, nepredpísané lieky, omamné látky, psychotropné látky, jedy, prekurzory;",
          "-> odsúdený, ktorý je trestné stíhaný, vykonáva trest alebo bol v minulosti právoplatne odsúdený ako člen organizovanej skupiny, zločineckej skupiny alebo extrémistickej skupiny, je pre tieto skupiny činný alebo ich podporuje; je trestne stíhaný alebo bol odsúdený za trestné činy uvedené v § 47 ods. 2 Trestného zákona (2005) alebo v § 43 Trestného zákona (1961) - možnosť uloženia doživotného trestu;",
          "vysoké riziko:",
          "-> odsúdený, ktorý sa zúčastnil vzbury alebo bol organizátorom vzbury alebo odmietnutia zhromaždených obvinených alebo odsúdených rozísť sa alebo iného hromadného protiprávneho konania;",
          "-> odsúdený, ktorý počas výkonu väzby alebo výkonu trestu odňatia slobody spáchal úmyselný trestný čin;",
          "-> odsúdený ušiel alebo sa pokúsil o útek z výkonu väzby alebo z výkonu trestu odňatia slobody;",
          "-> odsúdený, ktorý  fyzicky napadol príslušníka/zamestnanca ozbrojeného zboru v súvislosti s výkonom jeho služby alebo práce, alebo inú civilnú osobu,",
          "-> odsúdený vyrábal alebo prechovával zbrane, strelivo, predmety, ktoré boli vyrobené alebo prechovávané za účelom ohroziť život, zdravie alebo bezpečnosť osôb alebo majetku alebo ktoré by mohli slúžiť na vykonanie úteku obvinených alebo odsúdených;",
          "-> odsúdený, ktorý bol v súlade s internými predpismi vyhodnotený ako osoba s vysokou mierou rizika radikalizácie;"
        ],
        poznamka: [
          "Ak sa odsúdený dopustil viacerých konaní s rôznym bezpečnostným rizikom, tak sa v dotazníku označí riadok, v ktorom je najnebezpečnejšie z konaní odsúdeného."
        ]
      },

      expertne_posudenie: {
        name:
          "Expertné posúdenie - pravdepodobnosť, že posudzovaná osoba sa dopustí trestnej činnosti do 2 rokov od prepustenia",
        zdroj: [],
        priklad: [],
        poznamka: [],
        charakteristika: [
          "Expertné posúdenie znamená komplexné hodnotenie, ktoré je založené na teoretických znalostiach a praktických skúsenostiach hodnotiteľa – poskytuje odpoveď na otázku „Aká je z Vášho profesionálneho pohľadu na odsúdeného pravdepodobnosť jeho opakovaného zlyhania (trestnej činnosti) v najbližších dvoch rokoch?“"
        ]
      }
    }
  }),

  computed: {
    color() {
      if (this.form.expertne_posudenie == 0) return "grey";
      if (this.form.expertne_posudenie == 1) return "green";
      if (this.form.expertne_posudenie == 2) return "orange";
      if (this.form.expertne_posudenie == 3) return "red";
      return "grey";
    }
  },

  created() {
    this.getPBS();
  },

  methods: {
    appendIconCallback(nazov) {
      this.dialog = true;
      this.dialog_item = this.manual[nazov];
    },

    clear() {
      this.form.id = null;
      this.form.bezpecnostne_riziko = "";
      this.form.expertne_posudenie = "nehodnotené";
      this.skore = 0;
    },
    getPBS() {
      apiService.getPBS(this.$route.params.id).then(response => {
        this.form = response;
      });
      apiService.getCraForm(this.$route.params.id).then(response => {
        this.craItem = response;
      });
    },
    updateItem() {
      apiService.updatePBS(this.form, this.$route.params.id).then(
        () => {
          this.snackbar_saved = true;
        },
        () => {
          this.snackbar_error = true;
        }
      );
    },
    openItem() {
      apiService
        .updatePBS({ id: this.form.id, closed: false }, this.$route.params.id)
        .then(
          response => {
            this.snackbar_saved = true;
            this.form = response;
          },
          () => {
            this.snackbar_error = true;
          }
        );
    },

    closeItem() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          if (
            confirm(
              "Naozaj chcete uložiť a uzatvoriť túto časť formulára? (Následne nebude možné už formulár upravovať)"
            )
          ) {
            this.form.closed = true;

            apiService.updatePBS(this.form, this.$route.params.id).then(
              response => {
                this.snackbar_saved = true;
                this.form = response;
              },
              () => {
                this.snackbar_error = true;
              }
            );
          }
        } else {
          alert("Všetky položky musia byť vyplnené.");
        }
      });
    }
  }
};
</script>